import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientBeneficiarySettingsSaveMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { OnboardingProcessStepNameType } from 'api/types/entity';

import {
  parseOnboardingProcessEntity,
  parseOnboardingSettingsSaveParam,
} from '../../helpers';

export const useLegalClientBeneficiarySettingsSave = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBeneficiarySettingsSaveMutation();

  const error = useError(apolloError);

  const saveSettings = useCallback(
    async (
      legalId: string,
      beneficiaryId: string,
      currentStepName: OnboardingProcessStepNameType
    ) => {
      const input = parseOnboardingSettingsSaveParam(currentStepName);
      const res = await handle({
        variables: {
          id: legalId,
          beneficiaryId,
          input,
        },
      });
      return res.data?.legalClientBeneficiarySettingsSave?.process
        ? parseOnboardingProcessEntity(
            res.data?.legalClientBeneficiarySettingsSave?.process
          )
        : undefined;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    saveSettings,
  };
};
